/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Targetorchestratorv2FileMetaData } from '../models/Targetorchestratorv2FileMetaData';
import { HttpFile } from '../http/http';

/**
* Request to Upload the Target (the source file).
*/
export class V2UploadTargetFileRequest {
    'metadata'?: Targetorchestratorv2FileMetaData;
    /**
    * The actual source file.
    */
    'chunk'?: string;
    /**
    * Id of the org to which this target belongs
    */
    'orgId': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "Targetorchestratorv2FileMetaData",
            "format": ""
        },
        {
            "name": "chunk",
            "baseName": "chunk",
            "type": "string",
            "format": "byte"
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": "uuid"
        }    ];

    static getAttributeTypeMap() {
        return V2UploadTargetFileRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

